export const currentDeveloperCacheKey = "/companies/:company_id/developers/current" as const;
export const developersCacheKey = "/companies/:company_id/developers" as const;
export const sparseDevelopersCacheKey = "/companies/:company_id/developers_common" as const;
export const notificationSubscriptionsCacheKey = "/account_settings/notification_subscriptions" as const;
